module.exports = __webpack_public_path__ + "img/img-10-mobile.1adcc3cf.webp";